import API from "./api";

const normalizeListData = (data) => {
    if (Array.isArray(data)) {
        return data;
    }
    if (data.results && Array.isArray(data.results)) {
        return data.results;
    }
    return [];
};

const isFileLikeValue = (value) => {
    if (!value) return false;

    if (Array.isArray(value)) {
        return value.length > 0 && !!value[0]?.rawFile;
    }

    return !!value?.rawFile;
};

const buildDownloadsFormData = (data) => {
    const formData = new FormData();

    if (data.title !== undefined) {
        formData.append("title", data.title ?? "");
    }

    if (data.description !== undefined) {
        formData.append("description", data.description ?? "");
    }

    if (data.system_name !== undefined) {
        formData.append("system_name", data.system_name ?? "");
    }

    if (data.version !== undefined) {
        formData.append("version", data.version ?? "");
    }

    if (data.category !== undefined) {
        formData.append("category", data.category ?? "template");
    }

    if (data.is_active !== undefined) {
        formData.append("is_active", data.is_active ? "true" : "false");
    }

    if (data.sort_order !== undefined) {
        formData.append("sort_order", data.sort_order ?? 0);
    }

    let rawFile = null;

    if (Array.isArray(data.file) && data.file.length > 0) {
        rawFile = data.file[0]?.rawFile || null;
    } else if (data.file?.rawFile) {
        rawFile = data.file.rawFile;
    }

    if (rawFile) {
        formData.append("file", rawFile);
    }

    return formData;
};

const axiosDataProvider = {
    getList: async (resource, params) => {
        const url = `/${resource}/`;
        console.log("[dataProvider] GET LIST", url, params);

        const queryParams = new URLSearchParams();

        if (params?.pagination?.page) {
            queryParams.append("page", params.pagination.page);
        }

        if (params?.pagination?.perPage) {
            queryParams.append("page_size", params.pagination.perPage);
        }

        if (params?.sort?.field) {
            queryParams.append(
                "ordering",
                params.sort.order === "DESC"
                    ? `-${params.sort.field}`
                    : params.sort.field
            );
        }

        if (params?.filter) {
            Object.entries(params.filter).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                    queryParams.append(key, value);
                }
            });
        }

        const finalUrl = queryParams.toString()
            ? `${url}?${queryParams.toString()}`
            : url;

        const res = await API.get(finalUrl);
        const data = normalizeListData(res.data);

        return {
            data,
            total: Array.isArray(res.data?.results)
                ? (res.data?.count ?? data.length)
                : data.length,
        };
    },

    getOne: async (resource, params) => {
        const url = `/${resource}/${params.id}/`;
        console.log("[dataProvider] GET ONE", url, params);

        const res = await API.get(url);

        return {
            data: res.data,
        };
    },

    getMany: async (resource, params) => {
        console.log("[dataProvider] GET MANY", resource, params);

        const requests = params.ids.map((id) => API.get(`/${resource}/${id}/`));
        const responses = await Promise.all(requests);

        return {
            data: responses.map((res) => res.data),
        };
    },

    getManyReference: async (resource, params) => {
        const url = `/${resource}/`;
        console.log("[dataProvider] GET MANY REFERENCE", url, params);

        const res = await API.get(url);
        let data = normalizeListData(res.data);

        if (params.target && params.id !== undefined) {
            data = data.filter((item) => item[params.target] === params.id);
        }

        return {
            data,
            total: data.length,
        };
    },

    create: async (resource, params) => {
        const url = `/${resource}/`;
        console.log("[dataProvider] POST", url, params.data);

        if (resource === "downloads/files") {
            const formData = buildDownloadsFormData(params.data);

            const res = await API.post(url, formData);

            return {
                data: res.data,
            };
        }

        const res = await API.post(url, params.data);

        return {
            data: res.data,
        };
    },

    update: async (resource, params) => {
        const url = `/${resource}/${params.id}/`;
        console.log("[dataProvider] PUT", url, params.data);

        if (resource === "downloads/files") {
            const hasNewFile = isFileLikeValue(params.data.file);

            if (hasNewFile) {
                const formData = buildDownloadsFormData(params.data);
                const res = await API.put(url, formData);

                return {
                    data: res.data,
                };
            }

            const jsonData = {
                title: params.data.title,
                description: params.data.description,
                system_name: params.data.system_name,
                version: params.data.version,
                category: params.data.category,
                is_active: params.data.is_active,
                sort_order: params.data.sort_order,
            };

            const res = await API.put(url, jsonData);

            return {
                data: res.data,
            };
        }

        const res = await API.put(url, params.data);

        return {
            data: res.data,
        };
    },

    delete: async (resource, params) => {
        const url = `/${resource}/${params.id}/`;
        console.log("[dataProvider] DELETE", url, params);

        await API.delete(url);

        return {
            data: params.previousData,
        };
    },
};

export default axiosDataProvider;